import { z } from "zod";
import type { PlanKey } from "./plans.ts";

export const subscriptionStatusSchema = z.enum([
  "none",
  "incomplete",
  "trialing",
  "active",
  "past_due",
  "canceled",
  "unpaid",
  "expired",
  "refunded",
  "disputed",
]);
export type SubscriptionStatus = z.infer<typeof subscriptionStatusSchema>;

export const checkoutSchema = z.object({ plan: z.enum(["pro", "business"]) });

export type UsageDto = {
  periodKey: string;
  creditsGranted: number;
  creditsUsed: number;
  creditsRemaining: number;
  menus: number;
  publishedMenus: number;
  restaurants: number;
  members: number;
  storageBytes: number;
};

export type SubscriptionDto = {
  plan: PlanKey;
  /** Plan stored on the subscription record (may differ from effective plan e.g. after expiry). */
  subscribedPlan: PlanKey;
  status: SubscriptionStatus;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  billingConfigured: boolean;
  /** Top plan granted free of charge (the organization is owned by Dishfolio platform staff). */
  complimentary: boolean;
  usage: UsageDto;
  overLimit: string[];
};
